import React from "react";
import { MultiColumnList, TextLink } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { AccordionSection } from "./AccordionSection";
import { usePersonTitles } from "../hooks/usePersonTitles";
/** Path of the title detail page. */
export var getTitleDetailPath = function (titleId) {
    return "/bragency/titles/detail?id=".concat(encodeURIComponent(titleId));
};
/**
 * Contribution roles of the person in a title, shown the same way as in the
 * title's contributions table (codetable item descriptions); empty without roles.
 */
export var formatPersonTitleRoles = function (title) {
    var _a;
    return ((_a = title.roles) !== null && _a !== void 0 ? _a : [])
        .map(function (role) { return role.description || role.value; })
        .filter(Boolean)
        .join(", ");
};
var formatRoles = function (title) {
    return formatPersonTitleRoles(title) || "-";
};
/**
 * Person detail section "Uvedeno u titulů": the titles in which the person
 * appears as a title contribution, with its roles there and a link to each
 * title (DB-635). The backend already limits the titles to those the user may see.
 */
export var PersonTitlesSection = function (_a) {
    var kind = _a.kind, personId = _a.personId, open = _a.open, onToggle = _a.onToggle;
    var history = useHistory();
    var _b = usePersonTitles(kind, personId), _c = _b.data, titles = _c === void 0 ? [] : _c, isLoading = _b.isLoading, isError = _b.isError;
    var renderContent = function () {
        if (isLoading) {
            return (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" })));
        }
        if (isError) {
            return (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.titles.error" })));
        }
        if (titles.length === 0) {
            return (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.titles.empty" })));
        }
        return (React.createElement(MultiColumnList, { contentData: titles, columnMapping: {
                titleName: (React.createElement(FormattedMessage, { id: "ui-br-agency.person.titles.title.label" })),
                roles: (React.createElement(FormattedMessage, { id: "ui-br-agency.person.titles.roles.label" })),
            }, formatter: {
                titleName: function (title) { return (React.createElement(TextLink, { onClick: function () { return history.push(getTitleDetailPath(title.titleId)); } }, title.titleName || title.titleId)); },
                roles: formatRoles,
            }, visibleColumns: ["titleName", "roles"], isEmptyMessage: React.createElement(FormattedMessage, { id: "ui-br-agency.person.titles.empty" }), interactive: false }));
    };
    return (React.createElement(AccordionSection, { id: "person-titles", labelId: "ui-br-agency.person.titles.section.label", open: open, onToggle: onToggle }, renderContent()));
};
